export default `
<div class="ethics-doc">
  <h3 class="ethics-title">환경경영정책</h3>

  <p class="ethics-company">주식회사 이모션글로벌</p>

  <h5 class="ethics-article">1. 목적</h5>
  <p>이모션글로벌의 환경경영 정책은 고객, 비즈니스 파트너, 주주 및 사회의 다양한 이해관계자들의 행복을 위해 지속가능한 세상을 만드는데 목적이 있습니다. 이모션글로벌은 환경 친화적 기업 활동을 영위함으로써 환경 보전 및 개선을 위해 최선을 다하고 있습니다.</p>

  <h5 class="ethics-article">2. 적용 범위</h5>
  <p>이모션글로벌의 기업 활동을 영위하는 모든 구성원, 자회사, 투자회사, 협력업체 등에 이모션글로벌 환경경영 정책을 적용합니다. 아울러, 당사의 고객이나 비즈니스 파트너 등에도 환경정책의 준수를 기대합니다.</p>

  <h5 class="ethics-article">3. 추진 조직</h5>
  <p>이모션글로벌은 환경경영의 전사적 추진을 강화하기 위하여 이사회 산하 위원회인 ESG위원회에서 최종 의사결정을 수행하고 있습니다. 환경경영에 미치는 전반적인 이슈는 ESG총괄이 관리하고 있으며, 주요 이슈 발생 시에는 최고경영자(CEO)에게 보고됩니다. 최고경영자(CEO)는 주요 이슈사항에 대해 주 의사결정을 수행하며, 핵심 이슈사항에 대해서는 최고 의사결정기구인 이사회 및 ESG위원회에 보고하여 의사결정이 이뤄질 수 있도록 지원합니다.</p>

  <h5 class="ethics-article">4. 환경경영 방침</h5>
  <div class="ethics-intro">
    <p>이모션글로벌은 파리협약을 포함한 국제 환경 선언, 기준 및 규격을 공식적으로 지지하며 기업 활동 과정에서 발생하는 부정적인 환경영향을 최소화하고, 환경경영을 통한 사회적 가치 실현을 최우선적으로 추구하기 위해 아래와 같은 환경경영 방침을 제정하고 실행하고 있습니다.</p>
  </div>

  <div class="ethics-sub-sections">
  <h5 class="ethics-article">1) 환경 경영 시스템 (Environmental Management System)</h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 환경 관련 법규 준수를 기본으로 하며, 환경경영 시스템을 구축하고 내부 기준을 수립하고 준수합니다.</li>
    <li>- 이모션글로벌은 생산 활동 및 사업 시설이 환경에 미치는 영향을 최소화하기 위하여 환경 경영의 목표 수립부터 계획, 실행, 개선에 이르기까지 전 과정을 체계적으로 수립하고 정기적으로 평가합니다.</li>
  </ul>

  <h5 class="ethics-article">2) 생산 활동 및 사업 시설 (Production Activities and Business Facilities)</h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 생산 활동 및 사업 시설 전반에 걸쳐 환경경영을 핵심과제로 정의하고 있으며, 온실가스 감축 및 오염물질 최소화를 통해 지구 환경을 보전하고 있습니다.</li>
    <li>- 이모션글로벌은 친환경 ICT 상품 및 서비스 제공을 통해 환경을 보호해야 할 사회적 책임을 성실히 수행하며, 기후변화 및 자연자본에 대한 부정적인 환경 영향을 최소화하기 위해 노력합니다.</li>
  </ul>

  <h5 class="ethics-article">3) 폐기물 관리 (Management of Waste)</h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 순환경제의 중요성을 인지하고 있습니다.</li>
    <li>- 이모션글로벌은 기업활동에서 발생하는 폐기물을 최소화하고, 재활용을 늘리기 위해 보관, 운반, 처리 등에 관한 관리기준을 수립하여 운영하고 있으며, 정기적으로 내부 및 외부 검증을 시행합니다.</li>
  </ul>

  <h5 class="ethics-article">4) 생물다양성 보호와 산림 벌채 방지 (Biodiversity Conservation and No Deforestation) </h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 기업활동에서 전반에서 생물다양성의 최소순손실(NNL, No Net Loss) 및 순 긍정적 영향(NPI, Net positive impact)을 위한 최대한의 노력을 추진하며, 산림 벌채 방지와 산림 재생 전략을 추진하겠습니다.</li>
    <li>- 이모션글로벌은 생물다양성 보호와 산림훼손 방지를 위한 외부의 다양한 파트너십을 구축하며, 이러한 정책을 당사의 사업장 뿐 아니라 1차 공급망 및 1차 이외의 공급망에도 확대하겠습니다.</li>
  </ul>

  <h5 class="ethics-article">5) 실사, 인수 및 합병 (Due-diligence, mergers and acquisitions)</h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 인수 및 합병 추진 시 Due-diligence를 실시하여 환경측면의 법규 혹은 환경관리시스템 기준에 충족하지 못하는 잠재적 Risk를 파악하고 기업 가치 산정에 반영하고 있습니다.</li>
  </ul>

  <h5 class="ethics-article">6) 환경 정보 공개 (Disclosure)</h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 환경경영 방침 및 성과에 대해 글로벌 기준에 따라 고객, 구성원 이해관계자에 투명하게 공개합니다.</li>
  </ul>

  <h5 class="ethics-article">7) 이해관계자에 대한 인지 향상 (Stakeholders’ Awareness)</h5>
  <ul class="ethics-list">
    <li>- 이모션글로벌은 내부 및 외부 이해관계자들에게, 환경 및 환경경영의 중요성을 인지시키고 효율성을 향상 시키기 위해 노력하고 있습니다.</li>
    <li>- 이모션글로벌은 당사의 활동이 환경에 어떤 영향을 끼치는지(영향도, Impact)와 우리 회사가 환경으로부터 어떤 영향을 받는지(의존성, Dependency)를 내부이해관계자들에게 교육하고, 외부 이해관계자들에게 공개합니다.</li>
  </ul>
  </div>

  <h4 class="ethics-chapter ethics-supplement">부 칙</h4>
  <ul class="ethics-list">
    <li>① 이 규범은 2024년 12월 09일부터 제정한다.</li>
  </ul>
</div>
`;
